import { AddOnProductsDTO } from '../types';

export const getAddonProductsMock: AddOnProductsDTO = {
  addOnProducts: [
    {
      productCode: 'AP32_911_20',
      productName: '6 GB ekstra data',
      cmsRef: 'C3291120',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'AddOn',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'test2@gmail.dk',
      electronicDelivery: false,
    },
    {
      productCode: 'AP12_010_81',
      productName: 'TV2 Ude',
      cmsRef: 'C1201081',
      subscribed: true,
      recurringPrice: 5.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'Selectable',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'maich2@tdc.dk',
      electronicDelivery: true,
    },
    {
      productCode: 'AP12_060_05',
      productName: 'Bland Selv 46',
      cmsRef: 'C1206005',
      subscribed: true,
      recurringPrice: 450.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'BlandselvPackage',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'maich2@tdc.dk',
      electronicDelivery: true,
    },
    {
      productCode: 'AP12_060_06',
      productName: 'TV2 Ude 2',
      cmsRef: 'C1201082',
      subscribed: false,
      recurringPrice: 450.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'Selectable',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'maich2@tdc.dk',
      electronicDelivery: true,
    },
    {
      productCode: 'OFFICE_365',
      productName: 'Microsoft Office 365 Personal',
      cmsRef: 'OFFICE_365',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'Office365',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'test@tdc.dk',
      electronicDelivery: false,
    },
    {
      value: {
        securityPackageLicense: 'Q2Q7-0D26-HZ3U-0B5B-Z2LB',
      },
      productCode: 'AP89_301_00',
      productName: 'YouSee Sikkerhedspakke, DSL',
      cmsRef: 'C8930100',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackage',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'test@tdc.dk',
      electronicDelivery: false,
    },
    {
      productCode: 'AP57_840_03',
      productName: 'YouSee secure tillægspakke',
      cmsRef: 'C5784003',
      subscribed: true,
      recurringPrice: 49.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'AddOn',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'test@tdc.dk',
      electronicDelivery: false,
    },
  ],
};

export const postAddonProductsMock = {
  productName: 'TV2 Ude',
  parentProductName: 'Tilkøb',
  orderId: 'SSCR000033335',
  orderDate: '2022-06-13T21:28:56+02:00',
  cmsRef: 'C1201081',
  email: 'maich2@tdc.dk',
};

export const deleteAddonProductsMock = {
  cmsRef: 'C1123004',
  email: 'maich2@tdc.dk',
  orderDate: '2022-06-13T23:03:27+02:00',
  orderId: 'SSCR000033337',
  parentProductName: 'Tilkøb',
  productName: 'TV2 Ude',
  subscriptionId: '87837768814585B368E3A5DD6ED29CD3',
};
